import { RouteObject } from "react-router-dom";
import { lazy } from "react";

import { indentMenuItems } from "../mainMenuListIems";
import { UserPlus, User } from "react-feather";
import { userManagementUtil, AccessDenialForm } from "@siba/utilities";

/**
 * Component imports for Home module
 * **/
//const BlankPageWithOutlet = lazy(() => import('../BlankPageWithOutlet'));
const BlankPageWithOutlet = lazy(() => import("../BlankPageWithOutlet"));
const CompanyRoles = lazy(() => import("./AccessManagement/Roles/RolesGrid"));

export const companySettingMenu = indentMenuItems([
    {
        name: "User Management",
        path: "",
        icon: UserPlus,
        items: [
            {
                name: "Users",
                path: "/home/organisation/Settings/user",
                icon: User,
                items: undefined
            }
        ]
    },

    {
        name: "Access Management",
        path: "",
        icon: UserPlus,
        items: [
            {
                name: "Roles",
                path: "/home/organisation/Settings/access/roles",
                icon: User,
                items: undefined
            }
        ]
    }
]);

export const companySettingRouteObject: RouteObject = {
    path: "organisation",
    element: <BlankPageWithOutlet />,
    children: [
        {
            path: "settings",
            element: <BlankPageWithOutlet />,
            children: [

                {
                    path: "access",
                    element: <BlankPageWithOutlet />,
                    children: [
                        {
                            path: "Roles",
                            element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Relation"].some(
                                (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                            ) ? (
                                <CompanyRoles />
                            ) : (
                                <AccessDenialForm />
                            )
                        }
                    ]
                }
            ]
        }
    ]
};
